/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./menu-section-heading.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMenuSectionContext } from './menu-section-context';
var styles = {
  root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};

/**
 * __Menu section heading__
 *
 * A menu section heading {description}.
 */
export var MenuSectionHeading = function MenuSectionHeading(_ref) {
  var children = _ref.children;
  var id = useMenuSectionContext();
  return /*#__PURE__*/React.createElement("h2", {
    id: "".concat(id, "-heading"),
    className: ax([styles.root])
  }, children);
};